import { EPlanFormat } from './plan-format.enum';

export const DEFAULT_PLAN_FORMAT = EPlanFormat.PNG8;
